'use strict';

var ActionTypes = require('../constants/ActionTypes'),
    AppDispatcher = require('../AppDispatcher'),
    Analytics = require('../utils/Analytics'),
    AnalyticsEvents = require('../constants/AnalyticsEvents'),
    InvitationAPI = require('../api/InvitationAPI'),
    ActionUtils = require('../utils/ActionUtils'),
    SentInvitationStore = require('../stores/SentInvitationStore'),
    SocialFriendListStore = require('../stores/SocialFriendListStore');

var InvitationActionCreators = {
  requestInvitationsPage(isInitialRequest) {
    ActionUtils.requestPage({
      isInitialRequest: isInitialRequest,
      store: SentInvitationStore,
      action: ActionTypes.REQUEST_INVITATIONS,
      callAPI: InvitationAPI.requestInvitationsPage
    });
  },

  requestSocialFriendsPage(serviceType, isInitialRequest) {
    ActionUtils.requestIndexedPage({
      serviceType: serviceType,
      idAttribute: 'serviceType',
      isInitialRequest: isInitialRequest,
      store: SocialFriendListStore,
      action: ActionTypes.REQUEST_SOCIAL_FRIENDS,
      callAPI: InvitationAPI.requestSocialFriendsPage
    });
  },

  sendInvite(invite) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.SEND_INVITE
    });

    InvitationAPI.sendInvite(invite);

    Analytics.trackGAEvent(AnalyticsEvents.FORMS_SEND_INVITE_SEND, invite.serviceType);
    Analytics.trackEvent(AnalyticsEvents.FORMS_SEND_INVITE_SEND, {
      serviceType: invite.serviceType,
      serviceId: invite.serviceId,
      name: invite.name
    });
  },

  resendInvite(invite) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.RESEND_INVITE
    });

    InvitationAPI.resendInvite(invite.id);
  }
};

module.exports = InvitationActionCreators;



/** WEBPACK FOOTER **
 ** ./actions/InvitationActionCreators.js
 **/